<template>
  <section class="know-how-section">
    <article class="container">
      <header>
        <h2>Как это работает</h2>
      </header>

      <div class="content">
        <article class="left-part">
          <ul>
            <li>После регистрации вы получите доступ к базе всех активных предложений.</li>
            <li>
              В строке поиска каталога сырья вы сможете найти конкретную позицию и уточнить
              параметры поиска по товару.
            </li>
            <li>
              Разместите запрос на сырье, если предложения не подходят. Платформа в течение трех
              дней найдет подходящие варианты.
            </li>
            <li>
              Положите товар в корзину, укажите желаемую дату доставки, разместите заказ, отдыхайте.
            </li>
            <li>Поставка будет на вашем складе в срок, указанный в личном кабинете.</li>
          </ul>

          <footer>
            <ActionButton action="register">
              Зарегистрироваться
            </ActionButton>
          </footer>
        </article>

        <article class="right-part">
          <div class="card">
            <header>
              Мы постоянно расширяем ассортимент — напишите нам о новом сырье, если его нет в
              каталоге.
            </header>

            <img src="../../../../../assets/images/people-3.webp">
          </div>
        </article>
      </div>
    </article>
  </section>
</template>

<script>
import ActionButton from '../ActionButton/ActionButton.vue';

export default {
	name:       'SectionKnowHow',
	components: { ActionButton },
};
</script>

<style lang="scss" src="./SectionKnowHow.scss"/>
